exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.menu-title{display:inline-block;margin-right:5px\n}\n", "", {"version":3,"sources":["/data/jenkins/workspace/shop/src/components/layout/SiderBar/Item.vue"],"names":[],"mappings":";AAgCA,YACE,qBACA,gBAAiB;CAClB","file":"Item.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.menu-title{\n  display: inline-block;\n  margin-right: 5px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a38b6bd6","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/layout/SiderBar/Item.vue
// module id = sDPm
// module chunks = 2